import React, { ReactNode } from 'react';

import { LoginWrapper } from './sub/LoginWrappper';

interface AppProps {
    children: ReactNode;
};
export const App = (props: AppProps) => {
    const { children } = props;

    return (
        <div className="app">
            <LoginWrapper />
            {children}
        </div>
    );
};